export default {
	target: 'target',
	financialTarget: 'financialTarget',
	salary: 'salary',
	review: 'review',
	leaves: 'leaves',
	balance: 'balance',
	workDaysStats: 'workDaysStats',
	syncQueue: 'syncQueue',
	configuration: 'configuration',
	configurationFields: 'configurationFields',
	systemConfigValue: 'systemConfigValue',
};
